import React, { FC, useCallback } from 'react'

import * as SC from './styled'

export type NumberPickerProps = {
  min?: number
  max?: number
  value: number
  name: string
  onChange: (name?: string, value?: number) => void
}

const NumberPicker: FC<NumberPickerProps> = (props) => {
  const { min = 0, max, value, onChange, children, name } = props

  const decrease = useCallback(() => {
    if (value <= min) {
      return
    }
    return onChange(name, value - 1)
  }, [value, min, onChange, name])

  const increase = useCallback(() => {
    if (max && value >= max) {
      return
    }
    return onChange(name, value + 1)
  }, [max, value, onChange, name])

  return (
    <SC.NumberPicker>
      <SC.Button onClick={decrease} disabled={value <= min}>
        −
      </SC.Button>
      <SC.Text>{children}</SC.Text>
      <SC.Button
        className="-plus"
        onClick={increase}
        disabled={!!(max && value >= max)}
      >
        +
      </SC.Button>
    </SC.NumberPicker>
  )
}

export default NumberPicker
